'use client';

import { initDatadogForBrowser } from '@/libs/datadog/init';

initDatadogForBrowser();

export function SetupDatadog() {
  return null;
}
